export const selectUserProfile = state => state.auth.userProfile
export const selectUserEmail = state => state.auth.userEmail
export const selectUserIdentityId = state => state.auth.identityId
export const selectUserInfo = state => state.auth.info